module.exports = __webpack_public_path__ + "static/media/home-slider-2.250d2106.jpg";